import { toast } from "react-toastify";

export const messagesByAction = {
  Renovar: {
    success: "Auto renovado satisfactoriamente",
    error: "Error al renovar auto",
  },
  Migrar: {
    success: "Auto migrado satisfactoriamente",
    error: "Error al migrar auto",
  },
  Recommend: {
    success: "Auto recomendado satisfactoriamente",
    error: "Error al recomendar auto",
  },
  Pausar: {
    success: "Auto pausado satisfactoriamente",
    error: "Error al pausar auto",
  },
  Vender: {
    success: "Auto vendido satisfactoriamente",
    error: "Error al vender auto",
  },
  Eliminar: {
    success: "Auto eliminado satisfactoriamente",
    error: "Error al eliminar auto",
  },
};

export function showToast({ message, type }) {
  toast(message[type], {
    hideProgressBar: true,
    autoClose: 1500,
    type: type,
    theme: "colored",
    position: "bottom-right",
  });
}
